import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import call from 'src/assets/images/call.svg'
import renew from 'src/assets/images/Renew.svg'
import { INSURANCE_DETAILS } from 'src/utils/constants/InsuranceDetails'

const AllRenew = () => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <div className={classes.renewContainer}>
        <div className={classes.topTextContainer}>
          <p className={classes.renewTopText} data-test='renewText'>
            We are building a constructive plan to support you with the
            end-to-end Renew process.{' '}
          </p>
        </div>
        <div className={classes.renewImgContainer}>
          <img
            src={renew}
            className={classes.renewImg}
            alt=''
            data-test='claimImage'
          />
        </div>
        <div className={classes.bottomTextContainer}>
          <p className={classes.renewBottomText} data-test='bottomText'>
            However, reach out to us for any instant claim assistance.{' '}
          </p>
        </div>
        <div className={classes.contact}>
          <img src={call} className={classes.callImg} alt='' />
          <p className={classes.phone} data-test='phone'>
            {INSURANCE_DETAILS.HELP_MOBILE}
          </p>
        </div>
      </div>
    </div>
  )
}

export default AllRenew

const useStyles = makeStyles({
  container: { display: 'flex', justifyContent: 'center' },
  renewContainer: {
    width: '50vw',
    backgroundColor: 'white',
    borderRadius: '20px',
  },
  topTextContainer: {
    padding: '30px 0px 25px 0px',
    textAlign: 'center',
  },
  renewTopText: {
    margin: '0px 0px',
    color: '#6A6A6A',
    padding: '0px 150px',
  },
  renewBottomText: {
    margin: '0px 0px',
    color: '#333333',
    fontSize: '14px',
  },
  bottomTextContainer: {
    padding: '10px 0px 5px 0px',
    textAlign: 'center',
  },
  renewImg: {
    width: '40% !important',
  },
  renewImgContainer: {
    padding: '0px 0px',
    textAlign: 'center',
  },
  callImg: {
    width: '23px !important',
    paddingRight: '10px',
  },
  phone: {
    margin: '0px 0px',
    color: '#B92250',
    fontSize: '14px',
  },
  contact: {
    padding: '0px 0px 30px 0px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
})
